/*
 *  -----------------------------------------------------------------------
 *    <copyright file="snapshots/organisations-grid.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';

import { useTranslation } from 'hooks';
import ExpandableGrid from 'views/components/core/expandable/grid';

const OrganisationsGrid = ({ organisations, rowActions }: any) => {
    const { t } = useTranslation();

    return (
        <ExpandableGrid
            customKey="organisations"
            items={organisations}
            detail={null}
            showPager
            groupable={false}
            scrollable="scrollable"
            reorderable
            pageable={false}
            resizable
            addScroll
            options={{
                allowExcelExport: false,
                allowExpandCollapseAll: false,
                useFilterChips: false,
            }}
            columns={[
                {
                    label: t('admin:organisationName'),
                    id: 'snapshot-organisation-name',
                    field: 'name',
                    minWidth: 270,
                    lockedByDefault: true,
                },
                {
                    label: t('admin:parentSnapshot'),
                    id: 'snapshot-organisation-parent-snapshot',
                    field: 'parentSnapshot',
                    minWidth: 270,
                },
            ]}
            rowActions={rowActions}
        />
    );
};

export default OrganisationsGrid;
